// src/network-ids.ts
var NetworkId = /* @__PURE__ */ ((NetworkId2) => {
  NetworkId2["SOLANA_MAINNET"] = "solana:5eykt4UsFv8P8NJdTREpY1vzqKqZKvdp";
  NetworkId2["SOLANA_DEVNET"] = "solana:EtWTRABZaYq6iMfeYKouRu166VU2xqa1";
  NetworkId2["SOLANA_TESTNET"] = "solana:4uhcVJyU9pJkvQyS88uRDiswHXSCkY3z";
  NetworkId2["ETHEREUM_MAINNET"] = "eip155:1";
  NetworkId2["ETHEREUM_SEPOLIA"] = "eip155:11155111";
  NetworkId2["POLYGON_MAINNET"] = "eip155:137";
  NetworkId2["POLYGON_AMOY"] = "eip155:80002";
  NetworkId2["BASE_MAINNET"] = "eip155:8453";
  NetworkId2["BASE_SEPOLIA"] = "eip155:84532";
  NetworkId2["ARBITRUM_ONE"] = "eip155:42161";
  NetworkId2["ARBITRUM_SEPOLIA"] = "eip155:421614";
  NetworkId2["MONAD_MAINNET"] = "eip155:143";
  NetworkId2["MONAD_TESTNET"] = "eip155:10143";
  NetworkId2["BITCOIN_MAINNET"] = "bip122:000000000019d6689c085ae165831e93";
  NetworkId2["BITCOIN_TESTNET"] = "bip122:000000000933ea01ad0ee984209779ba";
  NetworkId2["SUI_MAINNET"] = "sui:35834a8a";
  NetworkId2["SUI_TESTNET"] = "sui:4c78adac";
  NetworkId2["SUI_DEVNET"] = "sui:devnet";
  return NetworkId2;
})(NetworkId || {});

// src/networks.ts
var NETWORK_CONFIGS = {
  // Solana Networks
  ["solana:5eykt4UsFv8P8NJdTREpY1vzqKqZKvdp" /* SOLANA_MAINNET */]: {
    name: "Solana Mainnet",
    chain: "solana",
    network: "mainnet",
    internalCaip: "solana:101",
    slip44: "501",
    explorer: {
      name: "Solscan",
      transactionUrl: "https://solscan.io/tx/{hash}",
      addressUrl: "https://solscan.io/account/{address}"
    }
  },
  ["solana:EtWTRABZaYq6iMfeYKouRu166VU2xqa1" /* SOLANA_DEVNET */]: {
    name: "Solana Devnet",
    chain: "solana",
    network: "devnet",
    internalCaip: "solana:103",
    slip44: "501",
    explorer: {
      name: "Solscan",
      transactionUrl: "https://solscan.io/tx/{hash}?cluster=devnet",
      addressUrl: "https://solscan.io/account/{address}?cluster=devnet"
    }
  },
  ["solana:4uhcVJyU9pJkvQyS88uRDiswHXSCkY3z" /* SOLANA_TESTNET */]: {
    name: "Solana Testnet",
    chain: "solana",
    network: "testnet",
    internalCaip: "solana:102",
    slip44: "501",
    explorer: {
      name: "Solscan",
      transactionUrl: "https://solscan.io/tx/{hash}?cluster=testnet",
      addressUrl: "https://solscan.io/account/{address}?cluster=testnet"
    }
  },
  // Ethereum Networks
  ["eip155:1" /* ETHEREUM_MAINNET */]: {
    name: "Ethereum Mainnet",
    chain: "ethereum",
    network: "mainnet",
    internalCaip: "eip155:1",
    chainId: 1,
    slip44: "60",
    explorer: {
      name: "Etherscan",
      transactionUrl: "https://etherscan.io/tx/{hash}",
      addressUrl: "https://etherscan.io/address/{address}"
    }
  },
  ["eip155:11155111" /* ETHEREUM_SEPOLIA */]: {
    name: "Ethereum Sepolia",
    chain: "ethereum",
    network: "sepolia",
    internalCaip: "eip155:11155111",
    chainId: 11155111,
    slip44: "60",
    explorer: {
      name: "Etherscan",
      transactionUrl: "https://sepolia.etherscan.io/tx/{hash}",
      addressUrl: "https://sepolia.etherscan.io/address/{address}"
    }
  },
  // Polygon Networks
  ["eip155:137" /* POLYGON_MAINNET */]: {
    name: "Polygon Mainnet",
    chain: "polygon",
    network: "mainnet",
    internalCaip: "eip155:137",
    chainId: 137,
    slip44: "137",
    explorer: {
      name: "Polygonscan",
      transactionUrl: "https://polygonscan.com/tx/{hash}",
      addressUrl: "https://polygonscan.com/address/{address}"
    }
  },
  ["eip155:80002" /* POLYGON_AMOY */]: {
    name: "Polygon Amoy",
    chain: "polygon",
    network: "amoy",
    internalCaip: "eip155:80002",
    chainId: 80002,
    slip44: "137",
    explorer: {
      name: "Polygonscan",
      transactionUrl: "https://amoy.polygonscan.com/tx/{hash}",
      addressUrl: "https://amoy.polygonscan.com/address/{address}"
    }
  },
  // Base Networks
  ["eip155:8453" /* BASE_MAINNET */]: {
    name: "Base Mainnet",
    chain: "base",
    network: "mainnet",
    internalCaip: "eip155:8453",
    chainId: 8453,
    slip44: "8453",
    explorer: {
      name: "Basescan",
      transactionUrl: "https://basescan.org/tx/{hash}",
      addressUrl: "https://basescan.org/address/{address}"
    }
  },
  ["eip155:84532" /* BASE_SEPOLIA */]: {
    name: "Base Sepolia",
    chain: "base",
    network: "sepolia",
    internalCaip: "eip155:84532",
    chainId: 84532,
    slip44: "8453",
    explorer: {
      name: "Basescan",
      transactionUrl: "https://sepolia.basescan.org/tx/{hash}",
      addressUrl: "https://sepolia.basescan.org/address/{address}"
    }
  },
  // Arbitrum Networks
  ["eip155:42161" /* ARBITRUM_ONE */]: {
    name: "Arbitrum One",
    chain: "arbitrum",
    network: "mainnet",
    internalCaip: "eip155:42161",
    chainId: 42161,
    slip44: "42161",
    explorer: {
      name: "Arbiscan",
      transactionUrl: "https://arbiscan.io/tx/{hash}",
      addressUrl: "https://arbiscan.io/address/{address}"
    }
  },
  ["eip155:421614" /* ARBITRUM_SEPOLIA */]: {
    name: "Arbitrum Sepolia",
    chain: "arbitrum",
    network: "sepolia",
    internalCaip: "eip155:421614",
    chainId: 421614,
    slip44: "42161",
    explorer: {
      name: "Arbiscan",
      transactionUrl: "https://sepolia.arbiscan.io/tx/{hash}",
      addressUrl: "https://sepolia.arbiscan.io/address/{address}"
    }
  },
  // Monad Networks
  ["eip155:143" /* MONAD_MAINNET */]: {
    name: "Monad Mainnet",
    chain: "monad",
    network: "mainnet",
    internalCaip: "eip155:143",
    chainId: 143,
    slip44: "60",
    // Uses Ethereum SLIP-44
    explorer: {
      name: "Monad Explorer",
      transactionUrl: "https://monadexplorer.com/tx/{hash}",
      addressUrl: "https://monadexplorer.com/address/{address}"
    }
  },
  ["eip155:10143" /* MONAD_TESTNET */]: {
    name: "Monad Testnet",
    chain: "monad",
    network: "testnet",
    internalCaip: "eip155:10143",
    chainId: 10143,
    slip44: "60",
    // Uses Ethereum SLIP-44
    explorer: {
      name: "Monad Testnet Explorer",
      transactionUrl: "https://testnet.monadexplorer.com/tx/{hash}",
      addressUrl: "https://testnet.monadexplorer.com/address/{address}"
    }
  },
  // Bitcoin Networks (for future support)
  ["bip122:000000000019d6689c085ae165831e93" /* BITCOIN_MAINNET */]: {
    name: "Bitcoin Mainnet",
    chain: "bitcoin",
    network: "mainnet",
    internalCaip: "bip122:000000000019d6689c085ae165831e93",
    slip44: "0",
    explorer: {
      name: "Blockstream",
      transactionUrl: "https://blockstream.info/tx/{hash}",
      addressUrl: "https://blockstream.info/address/{address}"
    }
  },
  ["bip122:000000000933ea01ad0ee984209779ba" /* BITCOIN_TESTNET */]: {
    name: "Bitcoin Testnet",
    chain: "bitcoin",
    network: "testnet",
    internalCaip: "bip122:000000000933ea01ad0ee984209779ba",
    slip44: "0",
    explorer: {
      name: "Blockstream",
      transactionUrl: "https://blockstream.info/testnet/tx/{hash}",
      addressUrl: "https://blockstream.info/testnet/address/{address}"
    }
  },
  // Sui Networks (for future support)
  ["sui:35834a8a" /* SUI_MAINNET */]: {
    name: "Sui Mainnet",
    chain: "sui",
    network: "mainnet",
    internalCaip: "sui:mainnet",
    slip44: "784",
    explorer: {
      name: "Sui Explorer",
      transactionUrl: "https://explorer.sui.io/txblock/{hash}?network=mainnet",
      addressUrl: "https://explorer.sui.io/address/{address}?network=mainnet"
    }
  },
  ["sui:4c78adac" /* SUI_TESTNET */]: {
    name: "Sui Testnet",
    chain: "sui",
    network: "testnet",
    internalCaip: "sui:testnet",
    slip44: "784",
    explorer: {
      name: "Sui Explorer",
      transactionUrl: "https://explorer.sui.io/txblock/{hash}?network=testnet",
      addressUrl: "https://explorer.sui.io/address/{address}?network=testnet"
    }
  },
  ["sui:devnet" /* SUI_DEVNET */]: {
    name: "Sui Devnet",
    chain: "sui",
    network: "devnet",
    internalCaip: "sui:devnet",
    slip44: "784",
    explorer: {
      name: "Sui Explorer",
      transactionUrl: "https://explorer.sui.io/txblock/{hash}?network=devnet",
      addressUrl: "https://explorer.sui.io/address/{address}?network=devnet"
    }
  }
};
function getNetworkConfig(networkId) {
  return NETWORK_CONFIGS[networkId];
}
function getExplorerUrl(networkId, type, value) {
  const config = getNetworkConfig(networkId);
  if (!config?.explorer)
    return void 0;
  const template = type === "transaction" ? config.explorer.transactionUrl : config.explorer.addressUrl;
  const placeholder = type === "transaction" ? "{hash}" : "{address}";
  return template.replace(placeholder, value);
}
function getSupportedNetworks() {
  return Object.keys(NETWORK_CONFIGS);
}
function getNetworksByChain(chain) {
  return Object.entries(NETWORK_CONFIGS).filter(([_, config]) => config.chain === chain).map(([networkId]) => networkId);
}
function chainIdToNetworkId(chainId) {
  return Object.keys(NETWORK_CONFIGS).find((id) => NETWORK_CONFIGS[id].chainId === chainId);
}
function networkIdToChainId(networkId) {
  return NETWORK_CONFIGS[networkId]?.chainId;
}
function networkIdToInternalCaip(networkId) {
  const config = NETWORK_CONFIGS[networkId];
  if (!config || !config.internalCaip) {
    throw new Error(`No internal CAIP mapping found for NetworkId: ${networkId}`);
  }
  return config.internalCaip;
}
function internalCaipToNetworkId(internalCaip) {
  const networkId = Object.keys(NETWORK_CONFIGS).find(
    (id) => NETWORK_CONFIGS[id].internalCaip === internalCaip
  );
  if (!networkId) {
    throw new Error(`No NetworkId mapping found for internal CAIP: ${internalCaip}`);
  }
  return networkId;
}

// src/analytics.ts
var ANALYTICS_HEADERS = {
  SDK_TYPE: "x-phantom-sdk-type",
  // server, browser-sdk, react-native-sdk
  SDK_VERSION: "x-phantom-sdk-version",
  // SDK version, e.g. 1.0.0
  PLATFORM: "x-phantom-platform",
  // firefox, chrome, safari, ios, android, etc.
  WALLET_TYPE: "x-phantom-wallet-type",
  // app-wallet, user-wallet
  APP_ID: "x-app-id",
  // Your application ID for identifying your app in analytics
  PLATFORM_VERSION: "x-phantom-platform-version"
  // OS version, device model, etc.
};

// src/environments.ts
var DEFAULT_AUTH_URL = "https://connect.phantom.app/login";
var DEFAULT_WALLET_API_URL = "https://api.phantom.app/v1/wallets";
var DEFAULT_EMBEDDED_WALLET_TYPE = "user-wallet";

// src/provider-names.ts
var PROVIDER_NAMES = {
  google: "Google",
  apple: "Apple",
  phantom: "Phantom",
  device: "Device",
  injected: "Wallet",
  deeplink: "Deeplink"
};
function getProviderName(provider) {
  return PROVIDER_NAMES[provider] || "Wallet";
}
export {
  ANALYTICS_HEADERS,
  DEFAULT_AUTH_URL,
  DEFAULT_EMBEDDED_WALLET_TYPE,
  DEFAULT_WALLET_API_URL,
  NETWORK_CONFIGS,
  NetworkId,
  PROVIDER_NAMES,
  chainIdToNetworkId,
  getExplorerUrl,
  getNetworkConfig,
  getNetworksByChain,
  getProviderName,
  getSupportedNetworks,
  internalCaipToNetworkId,
  networkIdToChainId,
  networkIdToInternalCaip
};
//# sourceMappingURL=index.mjs.map